import Axios from 'axios';

let axiosSelfCheckin = Axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosSelfCheckin.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');

    if (token) {
      config.headers.authorization = `Bearer ${token}`;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

axiosSelfCheckin.interceptors.response.use(
  (response) => response,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.clear();
      return (window.location.href = '/');
    }
    return Promise.reject(err);
  }
);

export default axiosSelfCheckin;
